import '../favicon.ico';
import './css/app.style.css';



// WEBPACK FOOTER //
// ./app/app-styles.js